import { generateVirtualMeta, DEFAULT_VALUE } from './main';

export const virtualiserActions = {
	generateVirtualMeta,
} as const;

export { DEFAULT_VALUE };
